import script from "./orderManageDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./orderManageDetail.vue?vue&type=script&setup=true&lang=js"

import "./orderManageDetail.vue?vue&type=style&index=0&id=0883e57f&lang=less"

const __exports__ = script;

export default __exports__